import { render } from "./Fridge.vue?vue&type=template&id=798f9fe5&scoped=true"
import script from "./Fridge.vue?vue&type=script&lang=js"
export * from "./Fridge.vue?vue&type=script&lang=js"

import "./Fridge.vue?vue&type=style&index=0&id=798f9fe5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798f9fe5"]])

export default __exports__